import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AiPlanningPlanEntrypointProps } from './AiPlanningPlanApp.tsx';

type AiPlanningPlanEntrypointComponent = EntryPointComponent<
	{},
	{},
	{},
	AiPlanningPlanEntrypointProps
>;

const createJiraSearch = (query: EntryPointRouteParams['context']['query']): string => {
	const searchParams = new URLSearchParams(query);
	const search = searchParams.toString();
	return search.length > 0 ? `?${search}` : '';
};

export const aiPlanningPlanEntrypoint: EntryPoint<
	AiPlanningPlanEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<AiPlanningPlanEntrypointComponent>(
		/* webpackChunkName: "async-ai-planning-plan-app" */ './AiPlanningPlanApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: { params },
			query,
		},
		tenantContext: { atlassianAccountId, cloudId },
	}: EntryPointRouteParams) => {
		const { planId } = params;

		if (planId == null || planId === '') {
			throw new Error('Plan id missing');
		}

		return {
			extraProps: {
				cloudId,
				accountId: atlassianAccountId,
				planId,
				jiraSearch: createJiraSearch(query),
			},
		};
	},
});
